import Link from '@uikit/components/Link/Link';
import clsx from 'clsx';
import styles from './SignetOverviewPageLink.module.scss';
import type { SignetOverviewPageLinkProps } from './types';

const SignetOverviewPageLink = ({
  className,
  children,
  path,
}: SignetOverviewPageLinkProps) => {
  return (
    <Link to={path} className={clsx(styles.link, className)}>
      {children}
    </Link>
  );
};

export default SignetOverviewPageLink;
